import FireBaseTools from '../utils/firebase';
import {
    GET_ITINERARY,
    SET_ITINERARY
} from './types';


export function getItinerary() {
    const request = FireBaseTools.getItinerary();
    return {
        type: GET_ITINERARY,
        payload: request
    };
}

export function setItinerary(itinerary) {
    const request = FireBaseTools.setItinerary(itinerary);
    return {
        type: SET_ITINERARY,
        payload: request
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/itinerary.js